import React from "react";

export default function DividerSlice() {
  return (
    <div className="DividerSlice" />
  )
}